"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _reactRouterDom = require("react-router-dom");

var _Elements = require("./Elements");

var _excluded = ["ariaLabel", "color", "href", "onClick", "size", "svg", "type"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      color = _ref.color,
      href = _ref.href,
      onClick = _ref.onClick,
      size = _ref.size,
      svg = _ref.svg,
      type = _ref.type,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      keyboardFocus = _useState2[0],
      setKeyboardFocus = _useState2[1];

  var onClickHandler = function onClickHandler(e) {
    setKeyboardFocus(false);

    if (onClick) {
      onClick(e);
    }

    if (e.type === 'keyup' && e.key === 'Enter' && href) {
      window.location.assign(href);
    }
  };

  var keyboardFocusHandler = function keyboardFocusHandler(e) {
    if (e.type === 'keyup') {
      if (e.key !== 'Escape') setKeyboardFocus(true);
    } else if (e.type === 'keydown' && e.key === 'Tab') setKeyboardFocus(false);else if (e.key === 'Enter') onClickHandler(e);
  };

  var eventHandlers = {
    onClick: onClickHandler,
    onKeyUp: keyboardFocusHandler,
    onKeyDown: keyboardFocusHandler
  }; // Under react-scripts v4.0, require returns an object, not a string

  var asset = require("../../assets/newIcons/".concat(svg, ".svg")); // eslint-disable-line


  var src = '';

  if (typeof asset === 'string') {
    src = asset;
  } else if ((0, _typeof2["default"])(asset) === 'object' && typeof asset["default"] === 'string') {
    src = asset["default"];
  }

  var internalLink = href && (!href.includes('http') || !href.includes('#'));
  var componentType = internalLink && _reactRouterDom.Link || href && 'a';
  var showOverlay = type === 'hover' || type === 'interactive' || onClick || href || ref;
  return /*#__PURE__*/_react["default"].createElement(_Elements.IconWrapper, (0, _extends2["default"])({
    "aria-label": ariaLabel,
    color: color,
    size: size,
    type: type
  }, rest), showOverlay && /*#__PURE__*/_react["default"].createElement(_Elements.IconOverlay, (0, _extends2["default"])({
    as: componentType,
    color: color,
    href: !internalLink && href,
    keyboardFocus: keyboardFocus,
    ref: ref,
    role: "button",
    tabIndex: "0",
    to: internalLink && href,
    type: type
  }, eventHandlers)), /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: src,
    uniquifyIDs: true
  }));
});

Icon.defaultProps = {
  ariaLabel: '',
  color: undefined,
  href: undefined,
  onClick: undefined,
  size: 'sm',
  stopPropagation: false,
  type: 'default'
};
Icon.propTypes = {
  ariaLabel: _propTypes["default"].string,
  color: _propTypes["default"].string,
  href: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  size: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'notificationBadge']),
  stopPropagation: _propTypes["default"].bool,
  svg: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].oneOf(['default', 'button', 'interactive', 'link'])
};
Icon.displayName = 'Icon';
var _default = Icon;
exports["default"] = _default;